import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import usePermissions from 'store/authentication/usePermissions';

import {
  PRODUCTION_VIEW_METRICS,
  PRODUCTION_EXTERNAL_VIEW_METRICS,
} from 'components/Metrics/constants/metricTypes';
import { RoutePrivateProps } from 'components/Route/Private/types';

const ProductionView = React.lazy(
  () => import('components/Production/View/View'),
);

function ScreensProductionsView(params: Readonly<RoutePrivateProps>) {
  const permissions = usePermissions('productions');
  return (
    <BaseLayout>
      <DocumentTitle>Production View</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ProductionView
          id={params.id ? parseInt(params.id as string, 10) : null}
          metricTypes={
            permissions.seeSensitiveData
              ? PRODUCTION_VIEW_METRICS
              : PRODUCTION_EXTERNAL_VIEW_METRICS
          }
          key={params.id}
        />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensProductionsView;
